// extracted by mini-css-extract-plugin
export default {"button":"Button_button__lm6zn","outlineButton":"Button_outlineButton__nhqlC","primaryButton":"Button_primaryButton__e9k95"};